"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseFactory = void 0;
const types_1 = require("../types");
const responseFactory = () => (payload, meta, status = types_1.ResponseStatus.SUCCESS) => ({
    payload,
    meta,
    status,
});
exports.responseFactory = responseFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZmFjdG9yeS9yZXNwb25zZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvQ0FBeUQ7QUFHbEQsTUFBTSxlQUFlLEdBQUcsR0FBc0IsRUFBRSxDQUFDLENBQ3RELE9BQXdCLEVBQ3hCLElBQVUsRUFDVixTQUF5QixzQkFBYyxDQUFDLE9BQU8sRUFDcEIsRUFBRSxDQUFDLENBQUM7SUFDL0IsT0FBTztJQUNQLElBQUk7SUFDSixNQUFNO0NBQ1AsQ0FBQyxDQUFBO0FBUlcsUUFBQSxlQUFlLG1CQVExQiJ9